import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="loading-button"
export default class extends Controller {
  static targets = ["button", "spinner", "label"]

  connect() {
    this._originalLabel = this.hasLabelTarget ? this.labelTarget.textContent : null
  }

  start() {
    if (!this.hasButtonTarget) return
    this.buttonTarget.disabled = true
    this.buttonTarget.classList.add("opacity-80", "cursor-wait")

    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
    if (this.hasLabelTarget) this.labelTarget.textContent = "Suggesting…"
  }

  stop() {
    if (!this.hasButtonTarget) return
    this.buttonTarget.disabled = false
    this.buttonTarget.classList.remove("opacity-80", "cursor-wait")

    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
    if (this.hasLabelTarget && this._originalLabel) this.labelTarget.textContent = this._originalLabel
  }
}


